export default {
  title: 'Sincronización de marca — Marcas',
  subtitle:
    'Resumen de todos los restaurantes del grupo y sus funciones sincronizadas. Solo el administrador de la cuenta puede realizar cambios.',
  alert: {
    message: 'Acceso solo para administrador',
    description:
      'Los cambios en el menú principal, precios y ofertas solo puede realizarlos el administrador de la cuenta. Todas las ubicaciones reciben actualizaciones automáticamente.',
  },
  locations: {
    title: 'Ubicaciones',
    description: 'Todos los restaurantes del grupo que comparten el menú maestro y la configuración',
    locations_zero: '0 ubicaciones',
    locations_one: '1 ubicación',
    locations_other: '{{count}} ubicaciones',
    synced: 'Sincronizado',
  },
  features: {
    title: 'Funciones sincronizadas',
    description: 'Estas funciones están controladas por la configuración principal',
    menus: {
      title: 'Menú principal',
      desription: 'Los artículos, categorías y descripciones del menú se sincronizan en todas las ubicaciones',
    },
    smart_pricing: {
      title: 'Precios inteligentes',
      desription: 'Las reglas de precios y ajustes se sincronizan en todas las ubicaciones',
    },
    offers: {
      title: 'Ofertas y promociones',
      desription: 'Las ofertas, descuentos y promociones activos se sincronizan en todas las ubicaciones',
    },
  },
};
